<template>
  <div>
    <loading-spinner v-if="isLoading" :status="$t('functional.authenticating')"></loading-spinner>
    <div id="app">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner.vue'

import axios from 'axios'

export default {
  name: 'app',
  components: {
    LoadingSpinner
  },
  beforeCreate () {
    this.requestedEnvelope = {
      envelopeFingerprint: this.$route.params.envelopeFingerprint,
      widgetCode: this.$route.params.widgetCode
    }

    this.$store.commit('setRequestedEnvelope', this.requestedEnvelope)

    axios.defaults.baseURL = process.env.VUE_APP_API_URL
  },
  computed: {
    isLoading () {
      return !this.$store.getters['auth/authAttempted'] && this.$route.meta.requiresAuth !== false
    }
  }
}
</script>

<style lang="sass">
  @import '@/styles/manifest.sass'
  #app
    position: relative

  .error-message
    text-align: center
</style>
